// bundle-accordion.js
(function () {
  // ----- Helpers -------------------------------------------------------------

  function getContent(item) {
    return item.querySelector('.bundle-item-content');
  }

  function setExpanded(btn, expanded) {
    if (!btn) return;
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  // ResizeObserver per accordion item so height matches real content at all times
  function attachResizeObserver(item) {
    const content = getContent(item);
    if (!content || item._ro) return;

    const ro = new ResizeObserver(() => {
      if (!item.classList.contains('active')) return;
      // measure current natural height and apply
      content.style.maxHeight = 'none';
      content.style.maxHeight = content.scrollHeight + 'px';
    });

    // Observe the container, and its children (covers images, font reflows, etc.)
    ro.observe(content);
    content.querySelectorAll('*').forEach((el) => ro.observe(el));

    item._ro = ro;
  }

  function detachResizeObserver(item) {
    if (item && item._ro) {
      item._ro.disconnect();
      item._ro = null;
    }
  }

  function expand(item) {
    const content = getContent(item);
    if (!content) return;

    // ensure visible padding during open animation
    content.style.paddingTop = '1rem';
    content.style.paddingBottom = '1rem';

    // set height to content's natural height for smooth open
    content.style.maxHeight = content.scrollHeight + 'px';

    item.classList.add('active');
    setExpanded(item.querySelector('.bundle-item-header'), true);

    // keep height in sync while open
    attachResizeObserver(item);
  }

  function collapse(item) {
    const content = getContent(item);
    if (!content) return;

    // animate closed
    content.style.maxHeight = '0px';
    content.style.paddingTop = '0';
    content.style.paddingBottom = '0';

    item.classList.remove('active');
    setExpanded(item.querySelector('.bundle-item-header'), false);

    // no need to keep observing
    detachResizeObserver(item);
  }

  function recalcIfOpen(item) {
    if (!item.classList.contains('active')) return;
    const content = getContent(item);
    if (!content) return;

    content.style.maxHeight = 'none';
    const h = content.scrollHeight;
    content.style.maxHeight = h + 'px';
  }

  // ----- Initialization per accordion section --------------------------------

  function initOneSection(root) {
    if (!root) return;

    // Mark up ARIA on headers, size any default-open items
    root.querySelectorAll('.bundle-item').forEach(function (item) {
      const btn = item.querySelector('.bundle-item-header');
      setExpanded(btn, item.classList.contains('active'));

      if (item.classList.contains('active')) {
        const content = getContent(item);
        if (content) {
          content.style.paddingTop = '1rem';
          content.style.paddingBottom = '1rem';
          content.style.maxHeight = content.scrollHeight + 'px';
          attachResizeObserver(item);
        }
      }
    });

    // Accordion header toggles
    root.querySelectorAll('.bundle-item-header').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        // allow "View" link to work without toggling
        if (e.target.closest('.view-product-button')) return;

        const item = btn.closest('.bundle-item');
        if (!item) return;

        if (item.classList.contains('active')) {
          collapse(item);
        } else {
          expand(item);
        }
      });
    });

    // Tabs (scoped per bundle item) — recalc height after switching
    root.querySelectorAll('.bundle-item').forEach(function (item) {
      const tabs = item.querySelectorAll('.tab .tablinks');
      const contents = item.querySelectorAll('.tabcontent');

      tabs.forEach(function (tabBtn) {
        tabBtn.addEventListener('click', function () {
          tabs.forEach(function (b) { b.classList.remove('active'); });
          contents.forEach(function (c) { c.classList.remove('active'); c.classList.add('hidden'); });

          tabBtn.classList.add('active');
          const target = item.querySelector('#' + tabBtn.dataset.tab);
          if (target) { target.classList.add('active'); target.classList.remove('hidden'); }

          recalcIfOpen(item);
        });
      });

      // Recalc when media load inside this item
      item.querySelectorAll('img, video, iframe').forEach(function (el) {
        el.addEventListener('load', function () { recalcIfOpen(item); });
        if (el.tagName === 'VIDEO') {
          el.addEventListener('loadedmetadata', function () { recalcIfOpen(item); });
        }
      });
    });

    // Variant switching — show only the active variant’s accordion in this section
    function showVariantAccordion(variantId) {
      if (!variantId) return;

      root.querySelectorAll('.bundle-variant-accordion').forEach(function (wrap) {
        const show = String(wrap.dataset.variantId) === String(variantId);
        wrap.style.display = show ? 'block' : 'none';

        if (show) {
          // Recalc heights for any open accordions in the shown block
          wrap.querySelectorAll('.bundle-item.active').forEach(function (item) {
            attachResizeObserver(item);
            recalcIfOpen(item);
          });
        } else {
          // Detach observers in hidden blocks
          wrap.querySelectorAll('.bundle-item').forEach(detachResizeObserver);
        }
      });
    }

    // Listen to common theme variant-change events
    ['variant:change', 'product:variant-change', 'theme:variant:change'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        const id = e && e.detail && e.detail.variant && e.detail.variant.id;
        if (id) showVariantAccordion(id);
      });
    });

    // Fallback: watch the product form id input
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idInput) {
      idInput.addEventListener('change', function () { showVariantAccordion(idInput.value); });
    }

    // Recalc on viewport changes
    const recalcAll = function () {
      root.querySelectorAll('.bundle-item.active').forEach(recalcIfOpen);
    };
    window.addEventListener('resize', recalcAll);
    window.addEventListener('orientationchange', recalcAll);

    // Handle URL ?variant= (themes that pushState)
    let lastVariant = null;
    function checkUrlVariant() {
      const qs = new URLSearchParams(location.search);
      const vid = qs.get('variant');
      if (vid && vid !== lastVariant) {
        lastVariant = vid;
        showVariantAccordion(vid);
      }
    }
    checkUrlVariant();
    setInterval(checkUrlVariant, 500);
  }

  // ----- Boot: init all sections (works with defer OR DOMContentLoaded) ------

  function initAll() {
    document.querySelectorAll('.bundle-accordion-section').forEach(initOneSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
